const MM_DD_YYYY = /^\d{2}\.\d{2}\.\d{4}$/;
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})/;

export function formatReleaseDate(value) {
  if (!value) return "";
  const str = String(value).trim();
  if (MM_DD_YYYY.test(str)) return str;
  const iso = ISO_DATE.exec(str);
  if (iso) return `${iso[2]}.${iso[3]}.${iso[1]}`;
  const parsed = new Date(str);
  if (Number.isNaN(parsed.getTime())) return str;
  const mm = String(parsed.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(parsed.getUTCDate()).padStart(2, "0");
  return `${mm}.${dd}.${parsed.getUTCFullYear()}`;
}
